import React from 'react';

import NoticeHeader from 'components/checkout/modal-notices/notice-headers/notice-header';

const NonRefundableParkingPackagesHeader = () => (
  <NoticeHeader headerImgSrc="/images/checkout/zag-no-refund.png">A quick heads up</NoticeHeader>
);

export default NonRefundableParkingPackagesHeader;
